export const getIOSInstallBrowser = (navigatorLike = navigator) => {
  const userAgent = navigatorLike?.userAgent || ""
  const platform = navigatorLike?.platform || ""
  const maxTouchPoints = navigatorLike?.maxTouchPoints || 0

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1)

  if (!isIOS) {
    return {
      isIOS: false,
      browser: null,
    }
  }

  if (/CriOS/.test(userAgent)) {
    return { isIOS: true, browser: "chrome" }
  }

  if (/FxiOS/.test(userAgent)) {
    return { isIOS: true, browser: "firefox" }
  }

  if (/Safari/.test(userAgent) && !/EdgiOS|OPiOS/.test(userAgent)) {
    return { isIOS: true, browser: "safari" }
  }

  return { isIOS: true, browser: "other" }
}
